// VIN code on the photo
(function () {
	document.addEventListener("DOMContentLoaded", function () {

		var div = document.getElementById("image-input");
		var form;

		if( div ) {
			form = div.getElementsByTagName("form")[0];
			form.id = "vinImage";

			document.getElementById("file-input").addEventListener("change", function() {
				// add background to the form
				form.style.background = "#ccc";
				
				// send request
				file_send();
			});
		}

		function file_send() {
			sendForm("vinImage", "/account/zbar", callback);
			return false;
		}

		function sendForm(form, url, callfunc) {
			if (!document.createElement) return;
			if (typeof (form) == "string") form = document.getElementById(form);
			var frame = createIFrame();
			var frameID = frame.id;
			var act = form.getAttribute('action');
			frame.onSendComplete = function () {
				callfunc(form, act, getIFrameXML(frame), frameID);
			};
			form.setAttribute('target', frame.id);
			form.setAttribute('action', url);
			form.submit();
		}

		function createIFrame() {
			var id = 'f' + Math.floor(Math.random() * 99999);
			var div = document.createElement('div');
			div.innerHTML = "<iframe style=\"display:none\" src=\"about:blank\" id=\"" + id + "\" name=\"" + id + "\" onload=\"sendComplete('" + id + "')\"&gt;&lt;/iframe>";
			document.body.appendChild(div);
			return document.getElementById(id);
		}

		function getIFrameXML(iframe) {
			var doc = iframe.contentDocument;
			if (!doc && iframe.contentWindow) doc = iframe.contentWindow.document;
			if (!doc) doc = window.frames[iframe.id].document;
			if (!doc) return null;
			if (doc.location == "about:blank") return null;
			if (doc.XMLDocument) doc = doc.XMLDocument;
			return doc;
		}

		function callback(form, act, doc, ID) {
			form.setAttribute('action', act);
			form.removeAttribute('target');
			
			//console.log(doc);
			
			/* GET VIN-CODE... */
			var vin;
			var codeID = "vin-img-code";
			var hasCodeAttr = "data-code";

			var vinEl = doc.getElementById(codeID);
			var codeFlag = true;
			var vinInput = document.getElementById("vin-form-input");
			var result = document.getElementById("fileError");

			if(vinEl) {
				vin = vinEl.innerText;
				vinInput.value = vin;
				result.style.display = "none";
				codeFlag = vinEl.getAttribute(hasCodeAttr);

				// console.log(vinEl);
				// console.log(codeFlag);

				// submit button
				if(codeFlag != "false") {
					// if true - submit button enabled
					document.getElementById("vin-form-btn").disabled = false;
					document.getElementById("vin-form-btn").removeAttribute("disabled");
				} else {
					// if false - submit bitton disabled
					document.getElementById("vin-form-btn").disabled = true;
					document.getElementById("vin-form-btn").setAttribute("disabled", "disabled");
				}

				// hidden fields with info and show vin-code input
				var dataVehicle = document.getElementById("dataVehicle");
				var vinForm = document.getElementById("vin-form");
				if(dataVehicle) dataVehicle.style.display = "none";
				vinInput.classList.remove("display_none");

			} else {
				result.style.display = "block";
			}

			// remove background to the form
			form.style.background = "";
			
			//remove iframe element
			document.body.removeChild(document.getElementById(ID).parentElement);
		}

	});
})();

function sendComplete(id) {
	var iframe = document.getElementById(id);
	if (iframe.onSendComplete &&
		typeof (iframe.onSendComplete) == 'function') iframe.onSendComplete();
};